import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=740b689a&scoped=true&"
import script from "./ResourceInfo.vue?vue&type=script&lang=js&"
export * from "./ResourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResourceInfo.vue?vue&type=style&index=0&id=740b689a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b689a",
  null
  
)

export default component.exports